<template>
  <a-layout>
    <a-form-model ref="form" :colon="false" :label-col="labelCol" :model="config" :rules="rules" :wrapper-col="wrapperCol">
      <a-row style="margin-left: -2%;margin-right: 2%">
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.warehouse')" prop="warehouse">
            <vxe-input v-model="warehouse.name" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.owner')" prop="owner">
            <vxe-select v-model="config.owner.id" :options="owners" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.logicalStore')" prop="logicalStoreIds">
            <vxe-select v-model="config.logicalStoreIds" :options="logicalStores" multiple style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.itemCategory')" prop="itemCategoryIds">
            <vxe-select v-model="config.itemCategoryIds" :options="itemCategories" multiple style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-layout>
</template>

<script>
import Vue from 'vue'
import { WAREHOUSE } from '@/store/mutation-types'
import api from '@/api'
import { findAll, findOne, post } from '@/api/Api'
import { Party } from '@/api/dto/common/Party'
import { getDictionaries, getOptions } from '@/utils/util'

export default {
  name: 'MaintenanceConfigDetail',
  data() {
    return {
      loading: false,
      warehouse: Vue.ls.get(WAREHOUSE),
      config: {
        owner: new Party(),
        itemCategories: [],
        logicalStores: [],
        logicalStoreIds: [],
        itemCategoryIds: []
      },
      itemCategoryNo: '',
      owners: [],
      logicalStores: [],
      itemCategories: [],
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      rules: {
        owner: [{ required: true, message: '货主不能为空' }],
        logicalStoreIds: [{ required: true, type: 'array', message: '逻辑仓不能为空' }],
        itemCategoryIds: [{ required: true, type: 'array', message: '商品类别不能为空' }]
      }
    }
  },
  created() {
    findAll('partyFactory', { available: true, 'type.ordinal': 1 }).then(res => {
      if (res.success) {
        this.owners = getOptions(res.result)
      }
      return getDictionaries('LOGICAL_STORE')
    }).then(result => {
      this.logicalStores = result
      return findOne('parameterFactory', { name: '商品类别层级' })
    }).then(res => {
      if (res.success) {
        this.itemCategoryNo = res.result.value
      }
      return getDictionaries(this.itemCategoryNo)
    }).then(result => {
      this.itemCategories = result
    })
  },
  methods: {
    fetch(record) {
      Object.assign(this.config, record)
      this.config.logicalStoreIds = record.logicalStores.map(item => item.id)
      this.config.itemCategoryIds = record.itemCategories.map(item => item.id)
    },
    clear() {
      this.config = {
        owner: new Party(),
        logicalStoreIds: [],
        itemCategoryIds: []
      }
    },
    save() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.config.logicalStores.length === 0) {
            return this.$message.warning('逻辑仓不能为空')
          }
          if (this.config.itemCategories.length === 0) {
            return this.$message.warning('商品类别不能为空')
          }
          const config = {
            'owner.id': this.config.owner.id,
            'logicalStore.ids': this.config.logicalStoreIds,
            'itemCategory.ids': this.config.itemCategoryIds,
            autoGenerate: true
          }
          post(api.save, { type: 'maintenanceConfigPersister' }, config).then(res => {
            if (res.success) {
              this.$message.success(this.$t('message.saveSuccess'))
              this.$emit('saveSuccess')
              this.clear()
            }
          })
        }
      })
    }
  }
}
</script>